module.exports = __webpack_public_path__ + "img/by-nc-sa.e1746d3e.jpg";